import React, { useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Table, { TYPES as TABLE_TYPES } from '../../../../components/table';
import { PARAMS } from '../../../../components/form/select';

import { QUESTION_FORM_STRUCT } from '../../../../store/struct/entities/client';

import styles from '../index.module.scss';

const ID = 'id';
const QUESTION = 'question';
const ANSWERS = 'answers';

const QuestionForm = ({
  onChange,
  data,
  questionFormResult,
  isResultEditing,
}) => {
  const questionForm = useMemo(() => {
    try {
      return JSON.parse(data).map((field, fieldIndex) => ({
        [ID]: fieldIndex,
        [QUESTION]: field[QUESTION_FORM_STRUCT.QUESTION],
        [ANSWERS]: [
          { [PARAMS.ID]: -1, [PARAMS.TITLE]: 'Выберите ответ' },
          ...field[QUESTION_FORM_STRUCT.ANSWERS].map((answer, index) => ({
            [PARAMS.TITLE]: answer,
            [PARAMS.ID]: index,
          })),
        ],
      }));
    } catch (e) {
      console.warn(e);
      return [];
    }
  }, [data]);

  const [state, setState] = useState(
    questionForm.reduce((result, field, index) => {
      result[index] = -1;

      return result;
    }, []),
  );
  const [initialStateFilled, setInitialStateFilled] = useState(false);

  const tableConfig = useMemo(
    () => [
      {
        type: TABLE_TYPES.TEXT,
        getValue: data => data[QUESTION],
      },
      {
        type: TABLE_TYPES.SELECT,
        onChange: (data, value) => {
          const newState = state.slice();

          newState[data[ID]] = value;
          setState(newState);
        },
        getValue: data => {
          return state ? state[data.id] : -1;
        },
        getOptions: data => data[ANSWERS],
        showZeroValue: isResultEditing,
      },
    ],
    [isResultEditing, state],
  );

  useEffect(() => {
    onChange(state);
  }, [state, onChange]);

  useEffect(() => {
    if (!initialStateFilled && questionFormResult.length > 0) {
      setState(questionFormResult);
      setInitialStateFilled(true);
    }
  }, [questionFormResult, initialStateFilled]);

  return (
    <Table
      className={styles.estimatesTable}
      headers={['Вопрос', 'Ответ']}
      config={tableConfig}
      data={questionForm}
    />
  );
};

QuestionForm.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default QuestionForm;
